import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppTree from './AppTree';
import { preloadNotFound, preloadRoute } from './App';
import { COHORT_PATHS } from './shared/fees/cohorts';
import './index.css';

const root = document.getElementById('root')!;
const landingPath = window.location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
const app = <AppTree Router={BrowserRouter} />;

if (['/', '/sell', ...COHORT_PATHS, '/tools/etsy-fee-audit', '/interest/privacy', '/interest/manage', '/interest/confirm'].includes(landingPath)) {
  void import('./landing/bootstrap').then(({ mountLanding }) => mountLanding(root, landingPath));
} else if (root.dataset.error === '404' && root.hasChildNodes()) {
  // The error shell is rendered before JavaScript too. Hydrate its existing metadata/layout
  // instead of creating a second set of title/robots elements with createRoot.
  void Promise.all([preloadRoute(landingPath), preloadNotFound()]).then(() => hydrateRoot(root, app));
} else if (root.dataset.prerender === landingPath && root.hasChildNodes()) {
  // Build-time HTML (scripts/prerender-guides.mjs): load the route's lazy modules first so the
  // first client render is synchronous and matches the markup, then hydrate in place.
  void preloadRoute(landingPath).then(
    () => { hydrateRoot(root, app); },
    () => { createRoot(root).render(app); },
  );
} else {
  createRoot(root).render(app);
}
